export default __webpack_public_path__ + "static/media/ICON.c17a0980.svg";